"use client";

import Masonry, { ResponsiveMasonry } from "react-responsive-masonry";
import ReviewCard from "@/components/ReviewCard";
import { UserReview, User } from '@prisma/client';

interface ExtendedUserReview extends UserReview {
  user: User;
  reviewerUser: {
    name: string;
    profileImageUrl: string;
  };
}

interface ReviewGridProps {
    reviewsToShow: ExtendedUserReview[];
    isPremium: boolean;
    reviewsToShowNumber: number;
    columnsCountBreakPoints: { [key: number]: number };
    hexColour: string;
    isLocationProfile?: boolean;
    isAdmin?: boolean;
    primaryBackgroundColour?: string;
    cardStyle?: string | null;
}
 
export function ReviewGrid({ reviewsToShow, isPremium, reviewsToShowNumber, columnsCountBreakPoints, hexColour, isLocationProfile, isAdmin, primaryBackgroundColour, cardStyle }: ReviewGridProps) {

  const colourToShow = isAdmin ? '#176CEB' : hexColour;

  return (
    <div>
    <ResponsiveMasonry columnsCountBreakPoints={columnsCountBreakPoints}>
      <Masonry gutter="1rem">
          {reviewsToShow.map((review, index) => {
            let isBlurred = !isPremium && index < reviewsToShow.length - reviewsToShowNumber;
            return (
              <div key={index} className={`${isBlurred ? 'blur-sm' : ''} w-full md:w-auto`}>
                <ReviewCard
                  review={review}
                  hexColour={colourToShow}
                  isLocationProfile={isLocationProfile}
                  isAdmin={isAdmin}
                  isBlurred={isBlurred}
                  primaryBackgroundColour={primaryBackgroundColour}
                  cardStyle={cardStyle}
                />
              </div>
            );
          })
        }
      </Masonry>
    </ResponsiveMasonry>
    </div>
  )
}